import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from '@challenger6/vm-pattern-library/modal';
import { LinkModule } from '@challenger6/vm-pattern-library/link';
import { MarkdownModule } from 'ngx-markdown';

import { ModalWithLinkComponent } from './modal-with-link.component';

@NgModule({
  declarations: [ModalWithLinkComponent],
  imports: [CommonModule, ModalModule, LinkModule, MarkdownModule],
  exports: [ModalWithLinkComponent],
})
export class ModalWithLinkModule {}
